// extracted by mini-css-extract-plugin
module.exports = {"container":"Sections_container__5JdQH","header":"Sections_header__3RKpM","contentWrapper":"Sections_contentWrapper__zs7_k"};